import { HttpInterceptorFn } from '@angular/common/http';

import { i18nCacheBustInterceptor } from '@shared/i18n/i18n-cache-bust.interceptor';
import { inputSafetyInterceptor } from '@shared/interceptors/input-safety.interceptor';

import { AppInterceptors } from '../app.interceptor';

/**
 * The app's HTTP interceptors, outermost first. `provideCore` puts `errorInterceptor` and `loadingInterceptor` in
 * front of them. The input-safety interceptor stays last, so it sees the final URL and a rejection it raises still
 * passes back through every other interceptor.
 */
export const KT_APP_INTERCEPTORS: readonly HttpInterceptorFn[] = [
  AppInterceptors.basicInterceptor,
  i18nCacheBustInterceptor,
  inputSafetyInterceptor,
];
